module.exports = __webpack_public_path__ + "img/job-video.6eed950.png";